import { useEffect } from 'react';
import { useFlagsmith } from 'flagsmith-react';
import { useDispatch, useSelector } from 'react-redux';
import { setFlags } from '../store/actions/featureFlags';

function useFlagsToStates({ features: featureNames }) {
  const { hasFeature, getValue } = useFlagsmith();
  const dispatch = useDispatch();
  const { flags, identityLoaded } = useSelector((state) => state.featureFlags);

  useEffect(() => {
    let changed = false;

    featureNames.forEach((featureName) => {
      const featureFlagValue = getValue(featureName);
      const featureFlagState = hasFeature(featureName);
      const featureValue = featureFlagValue || featureFlagState;

      if (!flags.hasOwnProperty(featureName) || flags[featureName] !== featureValue) {
        flags[featureName] = featureValue;
        changed = true;
      }
    });

    if (changed) {
      dispatch(setFlags(flags));
    }
  }, [dispatch, flags, featureNames, hasFeature, getValue]);

  return identityLoaded;
}

export default useFlagsToStates;
